var map = {
	"./Calendar-Delete.png": 47766,
	"./ada.png": 54139,
	"./alert_close_icon.png": 58377,
	"./api_logo_01.png": 6812,
	"./api_logo_02.png": 55079,
	"./api_logo_03.png": 85340,
	"./api_logo_04.png": 62852,
	"./ban_icon.png": 47677,
	"./batch_setting_icon_01.png": 47336,
	"./batch_setting_icon_02.png": 90034,
	"./batch_setting_icon_03.png": 19112,
	"./batch_setting_icon_04.png": 42749,
	"./batch_setting_icon_05.png": 25069,
	"./batch_setting_icon_06.png": 76878,
	"./batch_setting_icon_07.png": 49258,
	"./batch_setting_icon_08.png": 93867,
	"./bianaceLogo.png": 41550,
	"./binance.png": 20618,
	"./bitmart.png": 37548,
	"./bitmartLogo.png": 82467,
	"./btc.png": 97656,
	"./bybit.png": 33553,
	"./checked.png": 86298,
	"./close.png": 42266,
	"./close_icon.png": 82790,
	"./coinbase.png": 39799,
	"./copy-icon.png": 87987,
	"./copy_icon_white.png": 76588,
	"./cryptoicons/1inch.png": 39229,
	"./cryptoicons/ada.png": 44317,
	"./cryptoicons/akro.png": 25438,
	"./cryptoicons/ant.png": 46882,
	"./cryptoicons/atom.png": 75987,
	"./cryptoicons/bat.png": 70983,
	"./cryptoicons/bch.png": 35840,
	"./cryptoicons/bnb.png": 4792,
	"./cryptoicons/btc.png": 621,
	"./cryptoicons/btcst.png": 7842,
	"./cryptoicons/comp.png": 13514,
	"./cryptoicons/cos.png": 83113,
	"./cryptoicons/crv.png": 85985,
	"./cryptoicons/dash.png": 2713,
	"./cryptoicons/doge.png": 82736,
	"./cryptoicons/dot.png": 26402,
	"./cryptoicons/eos.png": 80551,
	"./cryptoicons/etc.png": 35657,
	"./cryptoicons/eth.png": 98574,
	"./cryptoicons/fil.png": 5589,
	"./cryptoicons/ftt.png": 91411,
	"./cryptoicons/grt.png": 98500,
	"./cryptoicons/iost.png": 74718,
	"./cryptoicons/jst.png": 39188,
	"./cryptoicons/kava.png": 14695,
	"./cryptoicons/link.png": 37041,
	"./cryptoicons/lit.png": 77805,
	"./cryptoicons/ltc.png": 90043,
	"./cryptoicons/mana.png": 64254,
	"./cryptoicons/mdx.png": 63547,
	"./cryptoicons/miota.png": 64796,
	"./cryptoicons/neo.png": 36875,
	"./cryptoicons/omg.png": 62126,
	"./cryptoicons/ont.png": 67863,
	"./cryptoicons/pancake.png": 93627,
	"./cryptoicons/reef.png": 53066,
	"./cryptoicons/rsr.png": 49706,
	"./cryptoicons/sun.png": 11344,
	"./cryptoicons/sushi.png": 94284,
	"./cryptoicons/sxp.png": 19341,
	"./cryptoicons/theta.png": 39315,
	"./cryptoicons/trx.png": 6113,
	"./cryptoicons/uni.png": 18435,
	"./cryptoicons/usdt.png": 83475,
	"./cryptoicons/xem.png": 62632,
	"./cryptoicons/xmr.png": 96769,
	"./cryptoicons/xrp.png": 74882,
	"./cryptoicons/xtz.png": 53215,
	"./cryptoicons/yfi.png": 30612,
	"./cryptoicons/yfii.png": 52318,
	"./cryptoicons/zec.png": 21404,
	"./cryptoicons/zen.png": 74954,
	"./cycle_icon.png": 45189,
	"./dash.png": 62554,
	"./down_arw.png": 23402,
	"./dropdown_icon_01.png": 43708,
	"./dropdown_icon_02.png": 531,
	"./dropdown_icon_03.png": 28503,
	"./dropdown_icon_04.png": 64957,
	"./dropdown_icon_05.png": 53045,
	"./dropdown_icon_06.png": 13395,
	"./dropdown_icon_07.png": 436,
	"./dropdown_icon_08.png": 9220,
	"./dropdown_icon_09.png": 95080,
	"./dropdown_icon_10.png": 17406,
	"./dropdown_icon_11.png": 51012,
	"./dropdown_icon_12.png": 71248,
	"./dropdown_icon_13.png": 16504,
	"./dropdown_icon_14.png": 14118,
	"./eth.png": 52762,
	"./eye_icon.png": 65771,
	"./fb_icon.png": 64693,
	"./gainbot_icon.png": 82601,
	"./gb_icon.png": 79857,
	"./genie.png": 77747,
	"./icon_01.png": 10405,
	"./icon_02.png": 65320,
	"./icon_03.png": 20302,
	"./icon_04.png": 16372,
	"./icon_04_old.png": 23042,
	"./icon_05.png": 20597,
	"./icon_06.png": 25570,
	"./icon_07.png": 90122,
	"./icon_08.png": 90369,
	"./icon_09.png": 45214,
	"./icon_10.png": 95536,
	"./icon_genie.png": 74792,
	"./icon_smart.png": 88912,
	"./icon_start.png": 21845,
	"./icon_zap.png": 84419,
	"./idcard_bg.png": 56731,
	"./info_icon.png": 24348,
	"./kucoin.png": 40739,
	"./kucoinLogo.png": 74494,
	"./kyc_verified_icon.png": 85171,
	"./lock.png": 307,
	"./logo.png": 74427,
	"./logo_icon.png": 52969,
	"./menuIcon-1.png": 84558,
	"./menuIcon-10.png": 71220,
	"./menuIcon-11.png": 58511,
	"./menuIcon-12.png": 57221,
	"./menuIcon-13.png": 22464,
	"./menuIcon-14.png": 95473,
	"./menuIcon-15.png": 46029,
	"./menuIcon-16.png": 55289,
	"./menuIcon-2.png": 14455,
	"./menuIcon-3.png": 54029,
	"./menuIcon-4.png": 42395,
	"./menuIcon-5.png": 31717,
	"./menuIcon-6.png": 33935,
	"./menuIcon-7.png": 12559,
	"./menuIcon-8.png": 5083,
	"./menuIcon-9.png": 25057,
	"./message_icon.png": 27919,
	"./minus.png": 4525,
	"./modal_close_btn.png": 39256,
	"./nodata.png": 61350,
	"./nouser_icon.png": 81360,
	"./oneshot_icon.png": 48690,
	"./pause_icon.png": 49151,
	"./pause_panic_icon.png": 47205,
	"./people.png": 40629,
	"./plus.png": 97477,
	"./popup_logo.png": 91274,
	"./power.png": 29090,
	"./qr-code.png": 64637,
	"./qr_code.png": 27539,
	"./qr_code_large.png": 47005,
	"./qr_small.png": 69558,
	"./right_arw.png": 68618,
	"./search.png": 17561,
	"./shape_bottom.png": 68406,
	"./shape_top.png": 68742,
	"./shareIcon.png": 21154,
	"./share_modal_bg.png": 13059,
	"./smart.png": 48800,
	"./sol.png": 53429,
	"./sort_icon.png": 50331,
	"./start_panic_icon.png": 40274,
	"./telegram_icon.png": 25608,
	"./tic.png": 21378,
	"./trade-chart.png": 76924,
	"./trade_chart.png": 80867,
	"./uploadIcon.png": 94945,
	"./usdt.png": 81080,
	"./user.png": 44353,
	"./walletMenuIcon-1.png": 49025,
	"./walletMenuIcon-1x.png": 68570,
	"./walletMenuIcon-2.png": 62033,
	"./walletMenuIcon-2x.png": 9610,
	"./walletMenuIcon-3.png": 32472,
	"./walletMenuIcon-3x.png": 1821,
	"./walletMenuIcon-4.png": 22302,
	"./walletMenuIcon-4x.png": 2555,
	"./warning.png": 4291,
	"./whatsapp_icon.png": 55828,
	"./zap.png": 37937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;